import React from 'react';
import { Tag } from '@gerdau/hefesto/Tag';
import {
  EFabricationOrderStatus,
  fabricationOrderStatusMap
} from '../../store/ducks/fabrication-orders/types';

interface IFabricationOrderStatusColumnProps {
  status: EFabricationOrderStatus;
}

const statusVariantMap = new Map<EFabricationOrderStatus, string>();
statusVariantMap.set(EFabricationOrderStatus.ENVIADO, 'success');
statusVariantMap.set(EFabricationOrderStatus.CONFIRMADO, 'primary');
statusVariantMap.set(EFabricationOrderStatus.EM_PRODUCAO, 'primary');
statusVariantMap.set(EFabricationOrderStatus.PARCIALMENTE_FATURADO, 'success');
statusVariantMap.set(EFabricationOrderStatus.FATURADO, 'success');
statusVariantMap.set(EFabricationOrderStatus.CANCELADO, 'danger');
statusVariantMap.set(EFabricationOrderStatus.BLOQUEADO, 'danger');

const FabricationOrderStatusTag: React.FC<
  IFabricationOrderStatusColumnProps
> = ({ status }) => {
  return (
    <Tag
      variant={statusVariantMap.get(
        status.toString() as EFabricationOrderStatus
      )}
    >
      {fabricationOrderStatusMap.get(
        status.toString() as EFabricationOrderStatus
      )}
    </Tag>
  );
};

export default FabricationOrderStatusTag;
